const Function = require('core/src/function');
const _ = require('core/src/utils/legacy');

const ServerSentEvents = Function.extend(Function, 'ServerSentEvents');

ServerSentEvents.prototype.onInit = function (dependencies) {
	this.eventSource = undefined;

	let params = {
		'$stayAlive': 'dashboard',
		'$url': '',
		'$withCredentials': '',
		'$initialMessage': undefined
	};
	this.setParameters(params);

	this.setModelValidation({
		url   : ['isString', {default: '', warn: _.def}],
		withCredentials: ['isBoolean', {default: false, warn: _.def}],
		initialMessage: ['isPlainObject', {default: {}, warn: _.def}]
	});
};

ServerSentEvents.prototype.onExecute = function(){
	const self = this;
	const url = this.readModel('url');
	const withCredentials = this.readModel('withCredentials');
	const initialMessage = this.readModel('initialMessage');
	const isWebsocket = _.startsWith(url, 'ws://') || _.startsWith(url, 'wss://');

	if (!isWebsocket) {
		this.eventSource = new EventSource(url, {withCredentials});
		this.eventSource.onopen = function() {
			self.executeTriggers({
				type: 'connected'
			});
		};
	} else {
		this.eventSource = new WebSocket(url);
		this.eventSource.onopen = function() {
			if (_.isPlainObject(initialMessage) && !_.isEmpty(initialMessage)) {
				self.eventSource.send(JSON.stringify(initialMessage));
			}
			self.executeTriggers({
				type: 'connected'
			});
		};
	}

	this.eventSource.onmessage = async (event) => {
		let data = event.data;

		if (data instanceof Blob) data = await data.text();
		else if (data instanceof ArrayBuffer) data = new TextDecoder().decode(data);

		self.executeTriggers({
			type: 'messageReceived',
			data
		});
	};

	this.eventSource.onerror = (error) => {
		self.executeTriggers({
			type: 'error',
			error
		});
		self.eventSource.close();
	};
};

ServerSentEvents.prototype.onClose = function() {
	this.eventSource.close();
}

module.exports = ServerSentEvents;
